export interface GetCollectionLendCountRequest {
  collectionId: number
  collectionNo: string
}

export function GetCollectionLendCountRequestToJSON(
  value: GetCollectionLendCountRequest
): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
